/* eslint-disable no-undef */
import styles from './style.styl'

import { Component, createRef } from 'preact'

class Video extends Component {
  constructor (props) {
    super(props)

    this.wrapperRef = createRef()
    this.changeVolume = this.changeVolume.bind(this)
    this.state = {
      isMobile: typeof window !== 'undefined' ? window.innerWidth <= 600 : true
    }
  }

  loadVideo = () => {
    window.YT.ready(() => {
      this.player = new window.YT.Player(`youtube-player-${this.props.id}`, {
        videoId: this.props.id,
        width: '100%',
        height: '100%',
        playerVars: {
          controls: 0,
          autoplay: this.state.isMobile ? 0 : 1,
          rel: 0,
          showinfo: 0,
          playsinline: 1,
          modestbranding: 1,
          iv_load_policy: 3,
          enablejsapi: 1,
          autohide: 1
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onStateChange
        }
      })
    })
  }

  onPlayerReady = event => {
    if (!this.state.isMobile) {
      event.target.setVolume(0)
      event.target.playVideo()
    }
  }
  onStateChange = event => {
    if (event.data === 0) {
      event.target.playVideo()
    }
  }

  changeVolume () {
    this.player.setVolume(100 - this.player.getVolume())

    const button = document.getElementById('videoButton')
    if (!(100 - this.player.getVolume())) {
      button.innerHTML = `<svg viewBox='0 0 24 24' fill='none'>
          <path
            d='M13.9647 14.1462L21.884 22.0655L24 19.9496L4.05042 0L1.93445 2.11597L6.92185 7.10337L5.98487 8.04034H0V16.0202H5.98487L13.9647 24V14.1462Z'
            fill='#1A1A1A' />
          <path d='M13.9647 0.0605072V7.79832L10.0958 3.92941L13.9647 0.0605072Z'
            fill='#1A1A1A' />
          <path
            d='M18.9028 12.7364C18.9355 12.5057 18.9524 12.2699 18.9524 12.0302C18.9524 10.5676 18.3228 9.25204 17.3199 8.33975L15.98 9.81361L18.9028 12.7364Z'
            fill='#1A1A1A' />
          <path
            d='M23.9394 12.0964C23.9288 13.7366 23.5223 15.2828 22.8106 16.6443L20.5431 14.3767C20.8047 13.6434 20.9472 12.8535 20.9472 12.0303C20.9472 9.98271 20.0659 8.14102 18.6619 6.86383L20.6747 4.64949C22.6654 6.46028 23.9206 9.06544 23.9394 11.9641V12.0964Z'
            fill='#1A1A1A' />
            </svg>`
    } else {
      button.innerHTML = `<svg viewBox='0 0 24 24' fill='none'>
          <path
            d='M14 0L6 8H0V16H6L14 24V0ZM18.709 6.82052C20.1166 8.10094 21.0001 9.94728 21.0001 12C21.0001 14.2593 19.9298 16.2686 18.2686 17.5485L20.0977 19.9265C22.4547 18.1107 23.9791 15.267 23.9999 12.0663V11.9336C23.981 9.02769 22.7227 6.41595 20.727 4.60059L18.709 6.82052ZM16.0003 12C16.0003 11.4134 15.7478 10.8858 15.3456 10.52L17.3637 8.30017C18.3691 9.21476 19.0003 10.5336 19.0003 12C19.0003 13.6138 18.2357 15.0491 17.049 15.9633L15.2197 13.5853C15.6945 13.2197 16.0003 12.6455 16.0003 12Z'
            fill='#1A1A1A' />
        </svg>`
    }
  }

  intesectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadVideo()
      }
    })
  }

  componentDidMount () {
    const observer = new IntersectionObserver(this.intesectionCallback, {
      rootMargin: '0% 0% 100% 0%',
      threshold: 0
    })

    observer.observe(this.wrapperRef.current)
  }

  render () {
    return <div className={styles.videoWrap} ref={this.wrapperRef}>
      <div id={`youtube-player-${this.props.id}`} />
      {!this.state.isMobile && <button onClick={this.changeVolume} id='videoButton' aria-label='Mute or unmute'>
        <svg viewBox='0 0 24 24' fill='none'>
          <path
            d='M13.9647 14.1462L21.884 22.0655L24 19.9496L4.05042 0L1.93445 2.11597L6.92185 7.10337L5.98487 8.04034H0V16.0202H5.98487L13.9647 24V14.1462Z'
            fill='#1A1A1A' />
          <path d='M13.9647 0.0605072V7.79832L10.0958 3.92941L13.9647 0.0605072Z'
            fill='#1A1A1A' />
          <path
            d='M18.9028 12.7364C18.9355 12.5057 18.9524 12.2699 18.9524 12.0302C18.9524 10.5676 18.3228 9.25204 17.3199 8.33975L15.98 9.81361L18.9028 12.7364Z'
            fill='#1A1A1A' />
          <path
            d='M23.9394 12.0964C23.9288 13.7366 23.5223 15.2828 22.8106 16.6443L20.5431 14.3767C20.8047 13.6434 20.9472 12.8535 20.9472 12.0303C20.9472 9.98271 20.0659 8.14102 18.6619 6.86383L20.6747 4.64949C22.6654 6.46028 23.9206 9.06544 23.9394 11.9641V12.0964Z'
            fill='#1A1A1A' />
        </svg>
      </button>}
    </div>
  }
}

export default Video



// WEBPACK FOOTER //
// ./components/footerContent/Video.js